import React, {Component} from 'react'
import Spinner from "../../../../../components/Spinnner/Spinner";
import Pagination from "../../../../../components/DashboardComponents/Pagination";
import FontAwesomeComponent, {RemoveFontAwesome, SortIcon} from "../../../../../components/FontAwesomeComponent";
import classes from '../../Artists/styles/artist.module.css'
import queryString from 'query-string';
import {Link, NavLink} from "react-router-dom";
import {ModalView} from "../../../../../components/BootstrapModal";
import * as actions from '../../../../../layouts/RootLayout/rootLayout.reducer'
import {connect} from 'react-redux'
import {
    NepaliCurrency,
    ResetCMSButton,
    SearchCMSComponent, SearchSpecificIdCMSComponent,
    SubmitCMSButton
} from "../../../../../components/CMSFormComponents";
import HotelService from "../../../../../services/Shop/HotelService";
import ArtistImage from "../../../../../components/ArtistItem/ArtistImage";
import CategoryService from "../../../../../services/Shop/CategoryService";

class Hotels extends Component{

    state = {
        entities: [],
        page: 0,
        sortField: 'id',
        sortOrder: 'asc',
        totalPages: 0,
        noEntity: false,
        deleteEntity: {id: -1, deleteEntityName: ''},
        // NAME
        nameInputValue: '',
        name: '',
        // LOCATION
        locationInputValue: '',
        location: ''
    }

    componentDidMount() {
        let params = queryString.parse(this.props.location.search);
        if(JSON.stringify(params) !== '{}'){
            let tempState = {};
            if(params.name){
                tempState.name = params.name;
            }
            if(params.location){
                tempState.location = params.location;
            }
            if(params.sort){
                const values = params.sort.split(",");
                tempState.sortField = values[0];
                tempState.sortOrder = values[1];
            }
            if(params.page){
                tempState.page = +params.page;
            }
            this.setState(tempState);
            if(tempState.page === 0 ) this.getEntities()
        } else {
            this.getEntities();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.page !== this.state.page || prevState.sortField !== this.state.sortField || prevState.sortOrder !== this.state.sortOrder || prevState.name !== this.state.name || prevState.location !== this.state.location){
            this.getEntities();
            let url = `${this.props.location.pathname}?page=${this.state.page}&sort=${this.state.sortField},${this.state.sortOrder}`;
            url += this.state.name && this.state.name !== '' ? `&name=${this.state.name}`: '';
            url += this.state.location && this.state.location !== '' ? `&location=${this.state.location}`: '';
            this.props.history.push(url);
        }
    }

    getEntities = () => {
        this.setState({noEntity: false})
        HotelService.getPagedHotels({page: this.state.page, sortField: this.state.sortField, sortOrder: this.state.sortOrder, name: this.state.name, location: this.state.location}).then(
            res => {
                this.setState({entities: [...res.data.content], totalPages: res.data.totalPages, noEntity: res.data.content.length === 0 ? true : false});
            }
        );
    }

    handlePageClick = ({selected}) => {
        this.setState({page: selected});
    }

    onSearchHandler = (event) => {
        if(event) event.preventDefault();
        this.setState({page: 0, name: this.state.nameInputValue, location: this.state.locationInputValue});
    }

    onResetSearchHandler = (event) => {
        if(event) event.preventDefault();
        this.setState({page: 0, sortField: 'id', sortOrder: 'asc', nameInputValue: '', name: '', locationInputValue: '', location: ''});
    }

    sortByHandler = (field) => {
        if(this.state.sortField === field){
            this.setState({sortOrder: this.state.sortOrder === 'asc' ? 'desc' : 'asc', page : 0});
        } else {
            this.setState({sortField: field, sortOrder: 'asc', page: 0});
        }
    }

    gotoAddNewEntityPage = () => {
        this.props.history.push("/dashboard/hotels/new");
    }

    deleteEntity = (id) => {
        HotelService.deleteHotel(id).then(
            (res) => {
                this.props.sucessToast("Successfully Deleted " + res.data.name)
                this.getEntities();
            }
        ).catch(() => this.props.errorToast("Something went wrong"))
    }

    TopToolbar = () => {
        return (<>
                <button onClick={this.gotoAddNewEntityPage} className="btn btn-primary float-right"><FontAwesomeComponent name="fa-plus-circle"/> Add New Hotel</button>
                <div style={{display: "flex", justifyContent: "center", flexWrap: "wrap", clear: "both"}}>
                    <SearchCMSComponent title="Name" searchText={this.state.nameInputValue} fieldName={"name"} setSearchText={(value) => this.setState({nameInputValue: value})} entityServiceSearchCall={HotelService.searchForHotels}/>
                    <SearchCMSComponent title="Location" searchText={this.state.locationInputValue} fieldName={"location"} setSearchText={(value) => this.setState({locationInputValue: value})} entityServiceSearchCall={HotelService.searchForHotelLocations}/>
                </div>
                <div style={{display: "flex", justifyContent: "center", marginBottom: "10px"}}>
                    <SubmitCMSButton onSearch={this.onSearchHandler}/>
                    <ResetCMSButton onResetSearch={this.onResetSearchHandler}/>
                </div>
            </>
        );
    }

    render() {

        if(this.state.entities.length === 0 && this.state.noEntity){
            return (
                <>
                    {this.TopToolbar()}
                    <div className="card" style={{width: "80%", textAlign: "center", margin: "0 auto", maxWidth: "600px"}}>
                        <div className="card-body">
                            <h5 className="card-title">No Such Item Found</h5>
                            <button onClick={this.onResetSearchHandler} className="btn btn-primary">Reset</button>
                        </div>
                    </div>
                </>
            )
        }

        if(this.state.entities.length == 0){
            return (
                <Spinner/>
            );
        }

        return (
            <>
                {this.TopToolbar()}
                <Pagination handlePageClick={this.handlePageClick} totalPages={this.state.totalPages} currentPage={this.state.page}/>
                <table className="table table-hover">
                    <thead>
                    <tr>
                        <th onClick={this.sortByHandler.bind(this, 'id')} className={classes.clickableTableHeader} style={this.state.sortField === 'id' ? {backgroundColor: "#ccc"}: null} scope="col"># <SortIcon/></th>
                        <th></th>
                        <th onClick={this.sortByHandler.bind(this, 'name')} className={classes.clickableTableHeader} style={this.state.sortField === 'name' ? {backgroundColor: "#ccc"}: null} scope="col">Hotel Name <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'location')} className={classes.clickableTableHeader} style={this.state.sortField === 'location' ? {backgroundColor: "#ccc"}: null} scope="col">Location <SortIcon/></th>
                        {/*<th onClick={this.sortByHandler.bind(this, 'minPrice')} className={classes.clickableTableHeader} style={this.state.sortField === 'price' ? {backgroundColor: "#ccc"}: null} scope="col">Min Price <SortIcon/></th>*/}
                        {/*<th onClick={this.sortByHandler.bind(this, 'maxPrice')} className={classes.clickableTableHeader} style={this.state.sortField === 'price' ? {backgroundColor: "#ccc"}: null} scope="col">Max Price <SortIcon/></th>*/}
                        <th onClick={this.sortByHandler.bind(this, 'averageRating')} className={classes.clickableTableHeader} style={this.state.sortField === 'quantity' ? {backgroundColor: "#ccc"}: null} scope="col">Rating <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'sortOrder')} className={classes.clickableTableHeader} style={this.state.sortField === 'sortOrder' ? {backgroundColor: "#ccc"}: null} scope="col">Sort Order <SortIcon/></th>
                        <th onClick={this.sortByHandler.bind(this, 'disabled')} className={classes.clickableTableHeader} style={this.state.sortField === 'disabled' ? {backgroundColor: "#ccc"}: null} scope="col">Status <SortIcon/></th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.state.entities.map(entity => {
                            return (
                                <tr key={entity.id}>
                                    <th>{entity.id}</th>
                                    <td>{entity.hotelImages && <ArtistImage photoUrl={entity.hotelImages.reduce((a, b) => a.sortOrder < b.sortOrder ? a : b, "").url} size={2.5}/>}</td>
                                    <td>{entity.name.length < 40 ? entity.name : `${entity.name.slice(0, 40)}...`}</td>
                                    <td>{entity.location.length < 40 ? entity.location : `${entity.location.slice(0, 40)}...`}</td>
                                    {/*<td><NepaliCurrency value={entity.minPrice}/></td>*/}
                                    {/*<td><NepaliCurrency value={entity.maxPrice}/></td>*/}
                                    <td>{entity.averageRating}</td>
                                    <td>{entity.sortOrder}</td>
                                    <td>{entity.disabled ? <span className="badge badge-danger">Disabled</span> : <span className="badge badge-primary">Enabled</span>}</td>
                                    <td style={{display: "flex", justifyContent: "space-around"}}>
                                        <Link to={`${this.props.match.url}/${entity.id}`}><button className="btn btn-primary">Views</button></Link>
                                        <Link to={`${this.props.match.url}/${entity.id}/edit`}><button className="btn btn-warning">Edit</button></Link>
                                        <button onClick={() => this.setState({deleteEntity: {id: entity.id, name: entity.name}})} className="btn btn-danger" data-toggle="modal" data-target="#customModal">Remove</button>
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
                <ModalView title={`Delete ${this.state.deleteEntity.name}`} id={this.state.deleteEntity.id} body={`Are you sure you want to remove [${this.state.deleteEntity.id}] ${this.state.deleteEntity.name}?`} callback={this.deleteEntity} confirmLabel={<><RemoveFontAwesome/> Delete</>} buttonTheme="btn-danger"/>
            </>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        sucessToast: (message) => dispatch(actions.sucessToast(message)),
        errorToast: (message) => dispatch(actions.errorToast(message))
    }
}

export default connect(null, mapDispatchToProps)(Hotels);

